<template>
    <div>
        <span class="title">{{TeC.introduction.title}}</span>
        <br>
        <div v-for="part in TeC.introduction.parts">
            <span class="heading">{{part}}</span>
        </div>
        <br>

        <ol>
            <li v-for="chap in TeC.chapters">
                <span class="title">{{chap.title}}</span>
                <br>
                <div v-for="part in chap.parts">
                    <span class="heading">{{part}}</span>
                </div>
                <br>
                <br>
            </li>
        </ol>

    </div>
</template>

<script>
    import TeCJson from './TeC.json'

    export default {
        name: "TeC",
        components: {},
        data() {
            return {
                TeC: TeCJson

            }
        },
        created(){
            this.convertLineBreak();
        },
        methods: {
            convertLineBreak(text){
                this.TeC.introduction.parts  = this.TeC.introduction.text.split("\n");
                for (let i=0; i< this.TeC.chapters.length; i++){
                    this.TeC.chapters[i].parts  = this.TeC.chapters[i].text.split("\n");
                }
            }

        }
    }
</script>

<style scoped>

</style>
